<section>
    <div class="bg-white p-6">
        <h1 *ngIf="!materialsSelected" class="typography-title-m m-0">
            {{'create-claim.material-selection.title_select_materials' | translate}}
        </h1>

        <h1 *ngIf="materialsSelected" class="typography-title-m m-0">
            {{'create-claim.material-selection.title_materials_selected' | translate}}
        </h1>
        <div class="divider mt-3 mb-6"></div>

        <div *ngIf="!materialsSelected">
            <app-invoice-selection
                [userInfo]="userInfo"
                [initialSelectedInvoices]="initialSelectedInvoices"
                [type]="'claim'"
                [entityId]="claimInformation.claimInfo.id!"
                [relatedFabricators]="relatedFabricatorsSelectValues"
                (invoiceSelected)="onColorSelect($event)"
            ></app-invoice-selection>
        </div>
        <div *ngIf="materialsSelected">

            <div class="bg-info-background p-2 flex gap-2">
                <img class="w-[24px] h-[24px]" src="assets/icons/info.svg" alt="info">
                <div class="flex flex-col gap-1">
                    <p class="m-0 typography-body-m-regular">
                        {{'create-claim.material-selection.you_can_also_specify_the_area' | translate}}
                    </p>
                </div>
            </div>

            <div class="flex flex-col gap-4 mt-6">
                <ng-container *ngFor="let selectedMat of claimInformation.selectedMaterials">
                    <div class="flex">
                        <!--                    Color image-->
                        <div class="flex gap-2 items-center">
                            <img class="h-[69px] w-[69px]" [ngClass]="{'rounded-full': !!selectedMat.claimItem!.image}" [src]="selectedMat.claimItem!.image || 'assets/icons/no-image.svg'"
                                 alt="imageColor">
                            <div class="flex flex-col gap-1">
                                <p class="m-0 typography-title-s">
                                    {{ selectedMat.claimItem?.productName }}
                                </p>
                                <img *ngIf="brandStringToImage(selectedMat.claimItem?.productBrand)" class="w-[97px]" alt="imageBrand" [src]="brandStringToImage(selectedMat.claimItem?.productBrand)">
                                <p *ngIf="!brandStringToImage(selectedMat.claimItem?.productBrand)" class="typography-body-s-medium m-0">
                                    {{ selectedMat.claimItem?.productBrand }}
                                </p>
                            </div>
                        </div>
                        <div class="border-r border-divider mx-4"></div>
                        <!--                    Color info-->
                        <div class="flex flex-wrap gap-6 items-center">
                            <p class="m-0">
                                <span class="typography-body-m-regular">
                                    {{ 'global.finish' | translate }}:
                                </span>
                                <span class="typography-body-m-medium">
                                    {{ selectedMat.claimItem?.productFinish || '-' }}
                                </span>
                            </p>
                            <p class="m-0">
                                <span class="typography-body-m-regular">
                                    {{ 'global.thickness' | translate }}:
                                </span>
                                <span class="typography-body-m-medium">
                                    {{ selectedMat.claimItem?.productThickness || '-'  }}
                                </span>
                            </p>
                            <p class="m-0">
                                <span class="typography-body-m-regular">
                                    {{ 'global.format' | translate }}:
                                </span>
                                <span class="typography-body-m-medium">
                                    {{ selectedMat.claimItem?.productFormat || '-'  }}
                                </span>
                            </p>
                            <p class="m-0">
                                <span class="typography-body-m-regular">
                                    {{ 'global.lot_id' | translate }}:
                                </span>
                                <span class="typography-body-m-medium">
                                    {{ selectedMat.claimItem?.barCode || '-'  }}
                                </span>
                            </p>
                            <div class="flex gap-1 items-center">
                                <p class="m-0">
                                    <span class="typography-body-m-regular">
                                        {{ 'area_units' | translate }}:
                                    </span>
                                    <input
                                        *ngIf="selectedMat.isEditing"
                                        class="border border-primary-active w-[42px] px-4 typography-body-m-regular"
                                        type="number"
                                        [max]="selectedMat.totalQty || null"
                                        [min]="0"
                                        [(ngModel)]="selectedMat.selectedQty"
                                        (ngModelChange)="parseMinMaxValue($event, selectedMat)"
                                    >
                                    <span *ngIf="!selectedMat.isEditing"  class="typography-body-m-medium">
                                        {{ (selectedMat.selectedQty | number:'1.2-2') || 0 }}
                                    </span>
                                    <span class="typography-body-m-regular">
                                        {{ 'of' | translate }} {{ (selectedMat.totalQty | number:'1.2-2') || '-' }} {{ selectedMat.invoiceData?.measure }}
                                    </span>
                                </p>
                                <div *ngIf="!selectedMat.isEditing" class="flex items-center cursor-pointer" (click)="activateEditingSize(selectedMat)">
                                    <img src="assets/icons/edit.svg" alt="edit">
                                    <span class="typography-body-l-regular text-primary">
                                        {{'create-claim.material-selection.edit_size' | translate}}
                                    </span>
                                </div>

                                <div *ngIf="selectedMat.isEditing" class="flex gap-1 cursor-pointer" (click)="acceptNewSize(selectedMat)">
                                    <span class="typography-body-l-regular text-primary">
                                        {{'create-claim.material-selection.accept_size' | translate}}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</section>